// Phase 4 Plan — board-reanchor release epoch atom.
//
// Epoch counter that fires at the floor-drop beat (~t=900ms into a reveal
// cinematic) to signal EXISTING LetterCubeSprite cubes to start their
// old→new anchor glide, overlapping the new-cell cascade (Task 5).
//
// Producers: FlopReveal + RiverReveal call pulseBoardReanchor() when
// fsm.boardGrowReleased flips true (keyed at the same 900ms schedule
// as floor-drop in useRevealFSM).
//
// Consumers (Task 5): LetterCubeSprite reads via $boardReanchor.subscribe()
// and starts its position-anchor-tween when the epoch value changes.
//
// Atom semantics — MONOTONIC in production:
//   - The epoch is strictly increasing across the full match lifetime.
//     It is NEVER reset between reveals in production code. FlopReveal and
//     RiverReveal do NOT call resetBoardReanchor() on unmount.
//   - 0 = initial state (no pulse has fired yet). Cubes capture the current
//     epoch at construction time; a freshly-constructed cube skips the
//     immediate nanostores emit-on-subscribe if the epoch is already nonzero.
//   - N > 0 = monotonically increasing; a cube starts its glide only on a
//     strictly-greater epoch (if epoch <= _lastReanchorEpoch → skip).
//   - The monotonic contract is what lets a surviving cube glide on BOTH the
//     flop pulse (epoch 0→1) and the river pulse (epoch 1→2) without missing
//     the second glide. Resetting to 0 between reveals would collapse both
//     pulses to epoch=1, and the guard would skip the river glide (bug).
//
// resetBoardReanchor() — TEST-ONLY isolation:
//   Used only in *.test.ts beforeEach() to return the atom to a known
//   baseline between independent tests. Never call this in production code.

import { atom } from 'nanostores'

/** Floor-drop release epoch. Incremented once per reveal at the 900ms beat. */
export const $boardReanchor = atom<number>(0)

export function pulseBoardReanchor(): void {
  $boardReanchor.set($boardReanchor.get() + 1)
}

export function resetBoardReanchor(): void {
  $boardReanchor.set(0)
}
